import React from "react";
import {
    StandardModalFormGrid,
    StandardModalFormGroup,
    StandardModalInput,
    StandardModalLabel
} from "src/components";
import styled from "styled-components";

export const StyledInput = styled(StandardModalInput)`
    height: 2.5rem;
    width: 100%;
`;

const SingleInviteForm = ({ user }) => {

    const singlePerson = {
        firstName: user?.firstName ?? "",
        lastName: user?.lastName ?? "",
        email: user?.email ?? "",
        phoneNumber: user?.phoneNumber ?? ""
    };
    const fullName = `${singlePerson.firstName} ${singlePerson.lastName}`.trim();
    return (
        <StandardModalFormGrid columns="repeat(3, minmax(0, 1fr))">
            <StandardModalFormGroup>
                <StandardModalLabel>Name</StandardModalLabel>
                <StyledInput value={fullName} readOnly />
            </StandardModalFormGroup>
            <StandardModalFormGroup>
                <StandardModalLabel>Email</StandardModalLabel>
                <StyledInput value={singlePerson.email} readOnly />
            </StandardModalFormGroup>
            <StandardModalFormGroup>
                <StandardModalLabel>Mobile</StandardModalLabel>
                <StyledInput value={singlePerson.phoneNumber} readOnly />
            </StandardModalFormGroup>
        </StandardModalFormGrid>
    );
};

export default SingleInviteForm;
